import clean from 'lodash-clean';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'; // eslint-disable-line
import infiniteScroll from 'vue-infinite-scroll';
import ClickOutside from 'vue-click-outside';
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import Treeselect from '@riophae/vue-treeselect';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import ListItem from '../ListItem.vue';
import SolrService from '@/common/solr.service';
import StorageService from '@/common/storage.service';
import ModalContentFactory from '../ModalContentFactory/ModalContentFactory.vue';
import Spinner from '../Spinner.vue';
import {
  SolrNewsTypeName,
  SolrExhibitorTypeName,
  SolrProductTypeName,
  SolrBrandTypeName
} from '@/common/Utility';
import '@/assets/swiper/swiper.css';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import LanguageService from '@/common/language.service';

export default {
  name: 'ExhibitorDirectory',
  components: {
    Treeselect,
    Spinner,
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    ModalContentFactory,
    'ed-list-item': ListItem,
  },
  data() {
    return {
      options: {
        isLoading: false,
        hasPrintButton: false,
        windowWidth: 0,
        swiper: {
          slidesPerView: 1,
        },
        accordion: {
          animation: {
            duration: '200ms',
            timerFunc: 'ease',
          },
        },
        sorting: {
          default: ['A-Z', 'Z-A'],
          news: ['Datum aufsteigend', 'Datum absteigend'],
        },
        contactSwiper: {
          // slidesPerView: 'auto',
          slidesPerView: 4,
          watchOverflow: true,
          slidesPerColumn: 1,
          autoHeight: true,
          // width: 250,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            550: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 3,
            },
          },
        },
        productSwiper: {
          slidesPerView: 1,
          autoHeight: true,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        },
        brandSwiper: {
          slidesPerView: 5,
          autoHeight: true,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            550: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
        },
        badgesSwiper: {
          slidesPerView: 4,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
            },
            1024: {
              slidesPerView: 2,
            },
            1280: {
              slidesPerView: 3,
            },
          },
        },
        boothSwiper: {
          slidesPerView: 5,
          watchOverflow: true,
          autoHeight: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
            },
            480: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
        },
        mediaSwiper: {
          slidesPerView: 1,
          autoHeight: true,
          watchOverflow: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
        },
      },
      list: {
        displayedAmount: 25, // as much as "amountToLoad", see mounted hook
        amount: 0,
        offset: 0,
        items: [],
        itemsPushed: [],
        isTileMode: false,
        isSwitchVisible: true,
        isLoading: true,
        sorting: 'asc',
        lastSort: 'asc',
        hallSortArray: []
      },
      parsedLimitedFairUids: JSON.parse(this.limitedFairEvents),
      fairTitleMapping: {},
      splittedCategoriesLoaded: false,
      latestNews: [],
      resultObject: {
        payload: '',
        term: '',
        weight: 0,
      },
      filter: {
        limitedFairEvents: '',
        isFilterVisible: false,
        autocomplete: {
          isVisible: false,
          isLoading: false,
          arrowCounter: -1,
          results: [],
        },
        fairGroups: {
          defaultExpandLevel: 1,
          filterValue: [],
          options: [],
        },
        types: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        categoriesByFair: null,
        categories: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        news: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        travelDestinations: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
        halls: {
          defaultExpandLevel: 0,
          filterValue: [],
          options: [],
        },
      },
      detail: {
        isDetailVisible: false,
        entry: null,
        categories: [],
      },
      favourites: {
        showFavourites: false,
        items: [],
      },
      showLatestNews: true,
      newsOnly: false,
      exhibitorsTopOfTheList: [],
      pluginConfiguration: {
        limitedFairEvents: this.limitedFairEvents,
        fairGroups: this.fairGroups,
      },
      router: {
        oldRoute: null,
      },
    };
  },
  props: {
    lang: {
      Type: String,
      default: 'de',
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    aside: {
      type: Boolean,
      default: false,
    },
    onlySearch: {
      type: Boolean,
      default: false,
    },
    limitedFairEvents: {
      type: String,
      default: '',
    },
    fairGroups: {
      type: String,
      default: '',
    },
    listUrl: {
      type: String,
      default: '',
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    timeTablePath: {
      type: String,
      default: '',
    },
    woozlePath: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    expandedCategories: {
      type: Boolean,
      default: false,
    },
    expandCategoryDropdown: {
      type: Boolean,
      default: false,
    },
    splittedCategories: {
      type: Boolean,
      default: false,
    },
    hideResultAmount: {
      type: Boolean,
      default: false,
    },
    fairGroupsTitle: {
      type: String,
      default: 'Themenwelten',
    },
    hallsTitle: {
      type: String,
      default: 'Hallen',
    },
    categoriesTitle: {
      type: String,
      default: 'Kategorien',
    },
    travelDestinationTitle: {
      type: String,
      default: 'Reiseziele',
    },
    topOfTheListColor: {
      type: String,
      default: '',
    },
    topOfTheListOpacity: {
      type: Number,
      default: 0.8,
    },
  },
  computed: {
    amountToLoad() {
      if (this.terminalmode) {
        return 700;
      }
      return 25;
    },
    areAllCategoriesByFairsVisible() {
      return this.filter.fairGroups.filterValue.length === 0;
    },
    filterable() {
      return true;
    },
    filterButtonTooltip() {
      if (this.filter.isFilterVisible) {
        return this.$t('filter.close');
      }
      return this.$t('filter.open');
    },
    viewSizeMode() {
      let sizeMode = -1;
      if (this.options.windowWidth <= 768) {
        sizeMode = 0; /* tiny */
      } else if (this.options.windowWidth > 768 && this.options.windowWidth <= 1024) {
        sizeMode = 1; /* small */
      } else if (this.options.windowWidth > 1024 && this.options.windowWidth <= 1280) {
        sizeMode = 2; /* medium */
      } else if (this.options.windowWidth > 1280) {
        sizeMode = 3; /* big */
      }
      return sizeMode;
    },
    amountOfResultsShown() {
      let amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.results')}`;
      if (this.favourites.showFavourites && this.favourites.items.length > 0) {
        if (this.list.amount === 0) {
          amount = '';
        } else if (this.list.amount === 1) {
          amount = `${this.list.amount} ${this.$t('list.favouriteTooltip.name.singular')}`;
        } else {
          amount = `${this.formatNumber(this.list.amount)} ${this.$t('list.favouriteTooltip.name.plural')}`;
        }
      } else if (this.list.amount === 0) {
        amount = '';
      } else if (this.list.amount === 1) {
        amount = `${this.list.amount} ${this.$t('list.result')}`;
      }
      return amount;
    },
    areNoItemsLeft() {
      return this.list.displayedAmount >= this.list.amount;
    },
    areFiltersActive() {
      return this.filter.fairGroups.filterValue.length
        || this.filter.types.filterValue.length
        || this.filter.categories.filterValue.length
        || this.filter.news.filterValue.length
        || this.filter.travelDestinations.filterValue.length
        || this.filter.halls.filterValue.length;
    },
    showFairGroupsTree() {
      return this.filter.fairGroups.options.length > 1;
    },
    showTypesTree() {
      return this.filter.types.options.length > 1 && this.filter.types.options[0].id !== '|';
    },
    showCategoriesTree() {
      return (this.filter.categories.options.length > 0 && this.filter.categories.options[0].id !== '|') || this.splittedCategories;
    },
    showTravelDestinationsTree() {
      return this.filter.travelDestinations.options.length > 0 && this.filter.travelDestinations.options[0].id !== '|';
    },
    showHallsTree() {
      return this.filter.halls.options.length > 1 && this.filter.halls.options[0].id !== '|' && (this.filter.halls.options[0].id.toLowerCase() !== 'undefiniert' && this.filter.halls.options[0].id.toLowerCase() !== 'undefined');
    },
    showFilter() {
      let show = true;
      this.filter.types.filterValue.forEach((typeFilter) => {
        if (typeFilter.id === SolrNewsTypeName && this.filter.types.filterValue.length === 1) {
          show = false;
        }
      });
      return show;
    },
    showTypesFilter() {
      const emptyFilter = this.filter.travelDestinations.filterValue.length === 0
        && this.filter.categories.filterValue.length === 0
        && this.filter.halls.filterValue.length === 0;

      const otherFilterSelected = this.filter.travelDestinations.filterValue.length > 0
        || this.filter.categories.filterValue.length > 0
        || this.filter.halls.filterValue.length > 0;

      return emptyFilter || !otherFilterSelected;
    },
    areTreesShown() {
      return this.showFairGroupsTree
        || this.showTypesTree
        || this.showHallsTree
        || this.showCategoriesTree
        || this.showTravelDestinationsTree;
    },
    sortingLabels() {
      if (this.newsOnly) {
        return this.options.sorting.news;
      }
      return this.options.sorting.default;
    },
    sortingOptions() {
      return [
        {id: 'asc', label: this.sortingLabels[0]},
        {id: 'desc', label: this.sortingLabels[1]},
      ];
    },
    getNewsType() {
      return SolrNewsTypeName;
    },
    getProductType() {
      return SolrProductTypeName;
    },
    getRGBColor() {
      return this.parseHexToRgb(this.topOfTheListColor);
    },
    getTopOfTheListStyle() {
      if (this.getRGBColor !== null) {
        if (!Number.isNaN(this.topOfTheListOpacity)) {
          return `background: rgba(${this.getRGBColor.r},${this.getRGBColor.g},${this.getRGBColor.b}, ${this.topOfTheListOpacity});`;
        }
        return `background: rgba(${this.getRGBColor.r},${this.getRGBColor.g},${this.getRGBColor.b}, 0.8);`;
      }
      return '';
    }
  },
  created() {
    this.options.windowWidth = window.innerWidth;
    this.updateView();
  },
  mounted() {
    // we have to call updateView() at created and mounted
    // because treeselect isn't ready at created
    // but mounted is too late for the layout adjustments (jumps in frontend)
    this.list.displayedAmount = this.amountToLoad;
    if (this.expandedCategories) {
      this.filter.categories.defaultExpandLevel = 1;
    }
    this.fetchDataFromRouter();
    this.updateView();
    this.favourites.items = this.getFavourites();
    if (this.$route.name === 'ExhibitorFavourites') {
      this.toggleFavourites();
    }
    this.fetchLatestNews();

    if (!this.onlySearch) {
      if (sessionStorage.getItem('lms_query') !== null) {
        const query = sessionStorage.getItem('lms_query');
        try {
          this.resultObject = JSON.parse(query);
        } catch (e) {
          // If no object is given we start a normal search
          this.resultObject.term = query;
          this.resultObject.payload = '[{"type":"searchFromDifferentLocation"}]';
        }
        sessionStorage.removeItem('lms_query');
        this.autocompleteSearch(this.resultObject);
      } else {
        this.fetchExhibitors(0, this.amountToLoad, true);
      }
    }

    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.options.windowWidth = window.innerWidth;
        this.updateView();
        /* @todo: reinit slides */
      });
    });
    document.body.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.closeDetail();
      }
    });
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    async fetchExhibitors(offset, rows, firstLoad) {
      this.list.isLoading = true;
      /* only news filter is selected */
      if (this.filter.types.filterValue.length === 1
        && this.filter.types.filterValue[0].id === SolrNewsTypeName) {
        if (!this.newsOnly) {
          this.list.sorting = 'asc';
          this.newsOnly = true;
        }
      } else {
        this.newsOnly = false;
      }
      await SolrService.getData(
        this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
        this.pluginConfiguration.limitedFairEvents,
        this.filter.types.filterValue,
        this.filter.categories.filterValue,
        this.favourites.showFavourites,
        this.getFavourites(),
        this.filter.travelDestinations.filterValue,
        this.filter.fairGroups.filterValue,
        this.filter.halls.filterValue,
        offset,
        rows,
        this.list.sorting,
      ).then((response) => {
        this.list.amount = response.data.response.numFound;
        this.list.offset = response.data.response.start;

        const tempData = response.data.response.docs;
        tempData.forEach((item) => {
          // eslint-disable-next-line
          item.boothsInFair = this.getBoothsForFair(item);
        });

        if (this.list.lastSort === this.list.sorting) {
          if (firstLoad) {
            this.list.itemsPushed = response.data.response.docs;
          } else {
            this.list.itemsPushed.push(...response.data.response.docs);
          }
        } else {
          this.list.itemsPushed = response.data.response.docs;
          this.list.lastSort = this.list.sorting;
        }

        /* no split of result items for news */
        if (this.newsOnly) {
          this.list.items = {
            News: this.list.itemsPushed,
          };
        } else {
          /* split entries in letter groups */
          this.list.items = this.list.itemsPushed.reduce((newArray, arrayItem) => {
            const reg = /^\d+$/;
            let firstLetter;
            if (arrayItem.title !== undefined && arrayItem.title !== '') {
              if (reg.test(arrayItem.title[0])) {
                firstLetter = '#';
              } else {
                firstLetter = arrayItem.title[0].toLocaleUpperCase();
              }
            } else {
              // filter items with no title out
              if (arrayItem.title === '') {
                return newArray;
              }
              firstLetter = '#';
            }

            const returnArray = newArray;
            if (returnArray[firstLetter]) {
              returnArray[firstLetter].push(arrayItem);
            } else {
              returnArray[firstLetter] = [arrayItem];
            }
            return returnArray;
          }, {});
        }

        /* Fill sorting for hall values, this is not beautiful but we had no other choice */
        this.fillHallSortingValues();

        /* create fairGroups from config */
        this.filter.fairGroups.options =
          this.buildFairTree(JSON.parse(this.pluginConfiguration.fairGroups));
        this.filter.types.options =
          this.buildTypeTree(response.data.facets.type.buckets);
        this.filter.travelDestinations.options =
          this.buildPathTree(response.data.facets.travel_destination.buckets);
        this.filter.halls.options =
          this.buildPathTree(this.sortHallValues(response.data.facets.hall.buckets));
        if (!this.splittedCategories) {
          this.filter.categories.options =
            this.buildPathTree(response.data.facets.categories.buckets);
        }
      })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          if (firstLoad) {
            if (this.splittedCategories && !this.splittedCategoriesLoaded) {
              const parsedFairGroups = JSON.parse(this.fairGroups);
              [].forEach.call(parsedFairGroups, (parsedFairGroup) => {
                this.fairTitleMapping[parsedFairGroup.id] = parsedFairGroup.title;
              });
              this.fetchSplittedCategories();
            } else {
              this.updateView();
            }
          }
          this.list.isLoading = false;
        });

      /* only get top of the list when there is a category filter selected */
      if (this.filter.categories.filterValue.length > 0) {
        await SolrService.getData(
          this.resultObject.term.trim() ? this.resultObject.term.trim().toLowerCase() : '*:*',
          this.pluginConfiguration.limitedFairEvents,
          null,
          this.filter.categories.filterValue,
          this.favourites.showFavourites,
          this.getFavourites(),
          null,
          null,
          null,
          0,
          100,
          'asc',
          true,
        ).then((response) => {
          this.exhibitorsTopOfTheList = response.data.response.docs;
        }).catch((error) => {
          console.log('error: ', error);
        });
      } else {
        this.exhibitorsTopOfTheList = [];
      }
    },
    fetchSplittedCategories() {
      SolrService.getCategories(this.parsedLimitedFairUids)
        .then((response) => {
          if (response.data.grouped
            && response.data.grouped.fair_id
            && response.data.grouped.fair_id.groups) {
            this.fillCategorySelects(response.data.grouped.fair_id.groups);
          }
        })
        .catch((error) => {
          console.log('error: ', error);
        })
        .finally(() => {
          this.updateView();
          this.splittedCategoriesLoaded = true;
        });
    },
    fillCategorySelects(categoryObjects) {
      this.filter.categoriesByFair = {};
      [].forEach.call(categoryObjects, (categoryObject) => {
        const fairId = parseInt(categoryObject.doclist.docs[0].fair_id, 10);
        const fairCategories = categoryObject.doclist.docs[0].av_categories_fair || [];

        if (fairCategories.length === 0 && fairId !== 0) {
          // This does what "continue" does in normal languages
          return;
        }

        this.filter.categoriesByFair[fairId] = {
          options: this.buildPathTree(fairCategories),
          filterValue: [],
          defaultExpandLevel: this.filter.categories.defaultExpandLevel,
          visible: false
        };
      });
    },
    fetchLatestNews() {
      SolrService.getLatestNews(this.pluginConfiguration.limitedFairEvents)
        .then((response) => {
          this.latestNews = [];
          const tempNews = response.data.response.docs;
          tempNews.forEach((news) => {
            const singleNews = news;
            singleNews.av_exhibitor = JSON.parse(news.av_exhibitor_object);
            this.latestNews.push(singleNews);
          });
        })
        .catch((error) => {
          console.log('error: ', error);
        });
    },
    loadMoreExhibitors() {
      this.fetchExhibitors(this.list.displayedAmount, this.amountToLoad, false);
      this.list.displayedAmount = this.list.displayedAmount + this.amountToLoad;
    },
    updateView() {
      if (this.viewSizeMode === 2 && this.aside) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
      } else if (this.viewSizeMode === 1) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
        // this.setTreeselectExpandLevel(1);
      } else if (this.viewSizeMode === 0) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
        // this.setTreeselectExpandLevel(0);
      } else if (this.viewSizeMode === 2 && !this.aside) {
        this.list.isTileMode = true;
        this.list.isSwitchVisible = false;
      } else {
        if (!this.aside) {
          this.filter.isFilterVisible = true;
        }
        this.list.isSwitchVisible = true;
        // this.setTreeselectExpandLevel(1);
      }
    },
    buildPathTree(paths) {
      let currentPath;
      let lastPath;
      let node;
      let parent;
      const map = {
        '': {
          children: [],
        },
      };
      let stack = [''];

      for (let i = 0; i < paths.length; i += 1) {
        let nodes = '';

        /* split path into single layers ("|") */
        if (paths[i].val) {
          nodes = paths[i].val.split('|');
        } else {
          nodes = paths[i].split('|');
        }
        for (let j = 0; j < nodes.length; j += 1) {
          currentPath = `${nodes.slice(0, j + 1).join('|')}`;
          const name = nodes[nodes.length - 1];
          lastPath = stack[stack.length - 1];
          parent = map[lastPath];

          if (!map[currentPath]) {
            node = {
              id: currentPath,
              label: name,
              type: 'category',
              children: [],
            };
            parent.children.push(node);
            map[currentPath] = node;
          }
          stack.push(currentPath);
        }
        stack = stack.slice(0, 1);
      }
      return paths.length === 0 ? [] : clean(map[''].children);
    },
    sortHallValues(hallBuckets) {
      if (this.list.hallSortArray.length === 0) {
        return hallBuckets;
      }

      const newSorting = [];
      this.list.hallSortArray.forEach((hallName) => {
        [].forEach.call(hallBuckets, (hallBucket) => {
          if (hallBucket.val === hallName) {
            newSorting.push(hallBucket);
          }
        });
      });
      return newSorting;
    },
    buildFairTree(fairGroups) {
      /* get all fairEvents from config */
      const options = [];
      let node;

      for (let i = 0; i < fairGroups.length; i += 1) {
        node = {
          id: fairGroups[i].id,
          label: fairGroups[i].title,
          type: 'fair',
        };
        options.push(node);
      }
      return options;
    },
    buildTypeTree(types) {
      const options = [];
      let node;
      for (let i = 0; i < types.length; i += 1) {
        node = {
          id: types[i].val,
          label: this.returnItemType(types[i].val),
          type: 'type',
        };
        options.push(node);
      }
      return options;
    },
    setFilterVisiblity(visibility) {
      this.filter.isFilterVisible = visibility;
    },
    setNewsFilter() {
      this.filter.types.filterValue = [{
        id: SolrNewsTypeName,
        label: 'News',
        type: 'type',
      }];
      this.filter.fairGroups.filterValue = [];
      this.filter.halls.filterValue = [];
      this.filter.categories.filterValue = [];
      this.filter.travelDestinations.filterValue = [];
      this.applyFilter();
    },
    triggerAutocomplete() {
      if (this.resultObject.term.trim().length > 0) {
        SolrService.getAutocompleteSuggetions(
          this.resultObject.term.trim(),
          this.pluginConfiguration.limitedFairEvents,
          this.filter.fairGroups.filterValue,
          this.filter.types.filterValue,
          this.filter.categories.filterValue,
          this.filter.travelDestinations.filterValue,
          this.filter.halls.filterValue,
        ).then((response) => {
          const sliceOption = this.viewSizeMode === 0 || this.viewSizeMode === 1 ? 3 : 10;
          if (response.data.suggest.av[this.resultObject.term.trim()]) {
            let autocompleteResults = response.data.suggest.av[this.resultObject.term.trim()]
              .suggestions.slice(0, sliceOption);
            autocompleteResults.sort(
              (a, b) => {
                let sorting = 0;
                if (a.term.toLowerCase() !== b.term.toLowerCase()) {
                  sorting = a.term.toLowerCase() < b.term.toLowerCase() ? -1 : 1;
                }
                return sorting;
              },
            );
            if (this.splittedCategories) {
              autocompleteResults = autocompleteResults.filter((result) => {
                const payload = JSON.parse(result.payload);
                return payload[0].type !== 'category';
              });
            }
            this.filter.autocomplete.results = autocompleteResults;
          } else {
            this.filter.autocomplete.results = [];
          }
          if (this.filter.autocomplete.results.length > 0) {
            this.filter.autocomplete.isVisible = true;
          }
        })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {

          });
      } else {
        this.filter.autocomplete.isVisible = false;
      }
    },
    applySearch() {
      if (this.onlySearch) {
        this.options.isLoading = true;
        if (this.resultObject.payload === '') {
          this.resultObject.payload = '[{"type":"searchFromDifferentLocation"}]';
        }
        sessionStorage.setItem('lms_query', JSON.stringify(this.resultObject));
        window.location = this.listUrl;
      } else {
        this.list.itemsPushed = [];
        if (this.resultObject.term !== '') {
          this.showLatestNews = false;
        } else {
          this.showLatestNews = !this.areFiltersActive;
        }
        this.fetchExhibitors(0, this.amountToLoad, true);
      }
    },
    clearSearch() {
      this.resultObject.term = '';
      this.applySearch();
    },
    clearSearchWithoutNewRequest() {
      this.resultObject.term = '';
    },
    applySplittedCategoryFilter() {
      this.filter.categories.filterValue = [];
      const categoryKeys = Object.keys(this.filter.categoriesByFair);
      categoryKeys.forEach((categoryKey) => {
        if (this.filter.categoriesByFair[categoryKey]
          && this.filter.categoriesByFair[categoryKey].filterValue
          && this.filter.categoriesByFair[categoryKey].filterValue.length !== 0) {
          this.filter.categoriesByFair[categoryKey].filterValue.forEach((catObject) => {
            this.filter.categories.filterValue.push(catObject);
          });
        }
      });
      this.applyFilter();
    },
    applyFilter() {
      this.list.itemsPushed = [];
      this.list.displayedAmount = this.amountToLoad;
      this.fetchExhibitors(0, this.amountToLoad, true);
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
      if (this.resultObject.term === '') {
        this.showLatestNews = !this.areFiltersActive;
      } else {
        this.showLatestNews = false;
      }
    },
    resetSplittedCategoryFilterTree(fairUid) {
      this.filter.categoriesByFair[fairUid].filterValue = [];
      this.applySplittedCategoryFilter();
    },
    resetFilterTree(filterName) {
      this.filter[filterName].filterValue = [];
      if (filterName === 'categories') {
        const categoryKeys = Object.keys(this.filter.categoriesByFair);
        categoryKeys.forEach((key) => {
          if (this.filter.categoriesByFair[key]) {
            this.filter.categoriesByFair[key].filterValue = [];
          }
        });
      }
      this.applyFilter();
    },
    resetFilters() {
      this.filter.fairGroups.filterValue = [];
      this.filter.halls.filterValue = [];
      this.filter.types.filterValue = [];
      this.filter.categories.filterValue = [];
      if (this.splittedCategories) {
        const categoryKeys = Object.keys(this.filter.categoriesByFair);
        categoryKeys.forEach((key) => {
          if (this.filter.categoriesByFair[key]) {
            this.filter.categoriesByFair[key].filterValue = [];
          }
        });
      }
      this.filter.news.filterValue = [];
      this.filter.travelDestinations.filterValue = [];
      this.showLatestNews = true;
      this.applyFilter();
    },
    setCursorPosition() {
      const { search } = this.$refs;

      this.$nextTick(() => {
        search.focus();
        search.setSelectionRange(
          this.resultObject.term.length, this.resultObject.term.length,
        );
      });
    },
    autocompleteSearch(autocompleteItem) {
      // eslint-disable-next-line
      autocompleteItem.term = `"${autocompleteItem.term}"`;
      const payloads = JSON.parse(autocompleteItem.payload);
      this.resultObject = autocompleteItem;
      payloads.forEach((payload) => {
        switch (payload.type) {
          case 'category':
            this.filter.categories.filterValue.push({
              id: payload.path,
              label: payload.value,
              type: payload.type,
            });
            this.clearSearchWithoutNewRequest();
            this.applyFilter();
            break;
          case 'traveldestination':
            this.filter.travelDestinations.filterValue.push({
              id: payload.path,
              label: payload.value,
              type: payload.type,
            });
            this.clearSearchWithoutNewRequest();
            this.applyFilter();
            break;
          default:
            this.$refs.searchButton.click();
        }
      });
      this.closeAutocomplete();
    },
    autocompleteItemWithHighlight(item) {
      const payloads = JSON.parse(item.payload);
      let returnHtml = '';

      if (payloads[0].type === 'category') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.category')}</span>`;
      } else if (payloads[0].type === 'traveldestination') {
        returnHtml = `<span class="ed-filter__autocompleteItem--type">${this.$t('filter.travelDestination')}</span>`;
      }
      returnHtml += '<span class="ed-filter__autocompleteItem--title">';
      returnHtml += item.term.toString().replace(new RegExp(this.resultObject.term.trim(), 'ig'), match => `<span class="ed-filter__autocompleteItemHighlight">${match} </span>`);
      returnHtml += '</span>';

      return returnHtml;
    },
    onAutocompleteArrowDown() {
      if (this.filter.autocomplete.arrowCounter
        < this.filter.autocomplete.results.length - 1
        && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter + 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteArrowUp() {
      if (this.filter.autocomplete.arrowCounter > 0 && this.filter.autocomplete.isVisible) {
        this.filter.autocomplete.arrowCounter = this.filter.autocomplete.arrowCounter - 1;
      }
      if (this.filter.autocomplete.isVisible) {
        this.setCursorPosition();
      }
    },
    onAutocompleteEnter() {
      if (this.filter.autocomplete.arrowCounter !== -1) {
        this.resultObject = this
          .filter
          .autocomplete
          .results[this.filter.autocomplete.arrowCounter];
        this.resultObject.term = `"${this.resultObject.term}"`;
        this.closeAutocomplete();
      }
    },
    closeAutocomplete() {
      this.filter.autocomplete.isVisible = false;
      this.filter.autocomplete.arrowCounter = -1;
    },
    setTileMode(value) {
      this.list.isTileMode = value;
    },
    updateRoute(entry) {
      const numericId = this.getNumericId(entry.id);
      if (Number.isInteger(numericId)) {
        if (entry.type === SolrExhibitorTypeName) {
          this.$router.push({ name: 'Exhibitor', params: { exhibitorId: numericId } });
        } else if (entry.type === SolrNewsTypeName) {
          this.$router.push({ name: 'ExhibitorNews', params: { exhibitorId: entry.exhibitor_id, newsId: numericId } });
        } else if (entry.type === SolrProductTypeName) {
          if (entry.av_p_exhibitor) {
            const exhibitorId = JSON.parse(entry.av_p_exhibitor).id;
            this.$router.push({ name: 'ExhibitorProducts', params: { exhibitorId, productId: numericId } });
          }
        }
      } else {
        this.closeDetail();
      }
    },
    showDetail(entryId) {
      SolrService.getData(
        `id:${entryId}`,
        this.pluginConfiguration.limitedFairEvents,
        this.filter.types.filterValue,
        this.filter.categories.filterValue,
        this.favourites.showFavourites,
        this.getFavourites(),
        this.filter.travelDestinations.filterValue,
        this.filter.fairGroups.filterValue,
        this.filter.halls.filterValue,
        0,
        10, // eslint-disable-line
      ).then((response) => {
        if (response.data.response.docs[0]) {
          this.detail.entry = response.data.response.docs[0]; // eslint-disable-line
          this.detail.isDetailVisible = true;
          const targetElement = document.querySelector('#detail-modal');
          disableBodyScroll(targetElement);
        } else {
          /* no data for this id found -> list */
          this.closeDetail();
        }
      });
    },
    closeDetail() {
      if (this.router.oldRoute) {
        this.$router.push({ name: this.router.oldRoute.name, params: this.router.oldRoute.params });
      } else {
        if (this.$route.name !== 'ExhibitorDirectory' && this.$route.name !== 'ExhibitorFavourites') {
          this.$router.push({ name: 'ExhibitorDirectory' });
        }
        this.detail.isDetailVisible = false;
        this.detail.entry = null;
        clearAllBodyScrollLocks();
      }
    },
    isProductsNotEmpty(products) {
      if (!products) {
        return false;
      }
      return products.length !== 0;
    },
    getFavourites() {
      return JSON.parse(StorageService.getItem('favourites')) || [];
    },
    toggleFavourites() {
      this.favourites.items = this.getFavourites();
      if (this.favourites.showFavourites) {
        this.$router.push({name: 'ExhibitorDirectory'});
      } else {
        this.$router.push({name: 'ExhibitorFavourites'});
      }
      this.favourites.showFavourites = !this.favourites.showFavourites;
      this.applyFilter();
    },
    openPrintDialogue() {
      window.print();
    },
    setFavourite(id) {
      const existingEntries = this.getFavourites();
      if (existingEntries.includes(id)) {
        const index = existingEntries.indexOf(id);
        if (index > -1) {
          existingEntries.splice(index, 1);
        }
      } else {
        existingEntries.push(id);
      }
      StorageService.setItem('favourites', JSON.stringify(existingEntries));
      this.favourites.items = this.getFavourites();
      this.$forceUpdate();
      if (this.favourites.showFavourites) {
        this.applyFilter();
      }
      if (this.favourites.items.length === 0) {
        this.favourites.showFavourites = false;
      }
    },
    isFavourite(id) {
      const existingEntries = this.getFavourites();
      if (existingEntries.includes(id)) {
        const index = existingEntries.indexOf(id);
        return index > -1;
      }
      return false;
    },
    clearFavourites() {
      StorageService.removeItem('favourites');
      this.favourites.items = this.getFavourites();
      this.favourites.showFavourites = false;
      this.applyFilter();
    },
    setTreeselectExpandLevel(level) {
      const { treeselect } = this.$refs;
      if (treeselect !== undefined) {
        treeselect.traverseAllNodesByIndex((node) => {
          if (node.isRootNode) {
            node.isExpanded = level; // eslint-disable-line no-param-reassign
          }
        });
      }
    },
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    toggleProductAccordion() {
      this.detail.isProductAccordionOpen = !this.detail.isProductAccordionOpen;
    },
    toggleAccordion(event) {
      const panel = event.target.children[0];
      event.target.classList.toggle('active');
      panel.style.maxHeight = 100;
    },
    resetAccordions() {
      this.detail.isProductAccordionOpen = false;
      this.detail.isCategoryAccordionOpen = false;
      this.detail.isContactAccordionOpen = false;
    },
    printDetail() {
      window.print();
    },
    returnItemType(type) {
      switch (type) {
        case SolrExhibitorTypeName:
          return this.$t('list.type.exhibitor');
        case SolrProductTypeName:
          return this.$t('list.type.product');
        case SolrNewsTypeName:
          return this.$t('list.type.news');
        case SolrBrandTypeName:
          return this.$t('list.type.brand');
        default:
          return '';
      }
    },
    returnSocialMediaName(smType) {
      const type = parseInt(smType, 10);
      switch (type) {
        case 0:
          return 'Facebook';
        case 1:
          return 'Twitter';
        case 2:
          return 'LinkedIn';
        case 3:
          return 'YouTube';
        case 4:
          return 'Xing';
        case 5:
          return 'Instagram';
        case 6:
          return 'WhatsApp';
        case 7:
          return 'Snapchat';
        case 8:
          return 'Facebook Messenger';
        default:
          return '';
      }
    },
    getCategoryWithSpaces(category) {
      return category.replace(/\|/g, ' | ');
    },
    getNumericId(id) {
      const splittedId = id.split('|||');
      return parseInt(splittedId[splittedId.length - 1], 10);
    },
    fetchDataFromRouter() {
      if (this.$route.params.exhibitorId) {
        if (this.$route.params.newsId) {
          this.showDetail(`${SolrNewsTypeName}|||V2|||${this.$route.params.newsId}`);
        } else if (this.$route.params.productId) {
          this.showDetail(`${SolrProductTypeName}|||V2|||${this.$route.params.productId}`);
        } else {
          this.showDetail(`${SolrExhibitorTypeName}|||V2|||${this.$route.params.exhibitorId}`);
        }
      } else {
        this.closeDetail();
      }
    },
    getBoothsForFair(item) {
      const fairs = [];
      const boothsInFair = [];
      if (item['_childDocuments_']) { // eslint-disable-line
        item['_childDocuments_'].forEach((fair) => { // eslint-disable-line
          fairs.push(fair.fair_id);
        });
        item.av_booths.forEach((booth) => {
          if (fairs.indexOf(booth.fairId) !== -1) {
            boothsInFair.push(booth);
          }
        });
      }
      return boothsInFair;
    },
    filteredChildDocuments(exhibitor) {
      const documents = [];
      if (exhibitor._childDocuments_) {
        exhibitor._childDocuments_.forEach((childDoc) => {
          let found = false;
          if (exhibitor.fair_ids.includes(childDoc.fair_id)) {
            documents.forEach((document) => {
              if (document.fair_id === childDoc.fair_id) {
                found = true;
              }
            });
            if (!found) {
              documents.push(childDoc);
            }
          }
        });
        return documents;
      }
      return [];
    },
    parseHexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    fillHallSortingValues() {
      switch (LanguageService.getCurrentTYPO3Language()) {
        case 'en':
          this.list.hallSortArray = [
            'East entrance',
            'West entrance',
            'Atrium',
            'Hall 1',
            'Gallery hall 1',
            'Hall 2',
            'Hall 3',
            'Hall 4',
            'Hall 5',
            'Hall 6',
            'Hall 7',
            'Hall 8',
            'Hall 9',
            'Hall 10',
            'ICS',
            'Rothaus-Park',
            'Messepiazza',
            'Undefined'
          ];
          break;
        case 'de':
          this.list.hallSortArray = [
            'Eingang Ost',
            'Eingang West',
            'Atrium',
            'Halle 1',
            'Galerie Halle 1',
            'Halle 2',
            'Halle 3',
            'Halle 4',
            'Halle 5',
            'Halle 6',
            'Halle 7',
            'Halle 8',
            'Halle 9',
            'Halle 10',
            'ICS',
            'Rothaus-Park',
            'Messepiazza',
            'Undefiniert'
          ];
          break;
        default:
      }
    },
    hasNewsContent(firstLetterItems) {
      return Object.values(firstLetterItems).find(entry => entry.type === this.getNewsType && entry.content && entry.title) !== undefined;
    },
    isTypeNews(firstLetterItems) {
      return Object.values(firstLetterItems).find(entry => entry.type === this.getNewsType) !== undefined;
    },
    isValidNews(entry) {
      return entry.type === this.getNewsType && entry.content && entry.title;
    }
  },
  directives: {
    ClickOutside,
    infiniteScroll,
  },
  watch: {
    $route(route, oldRoute) {
      if (route.name === 'ExhibitorNews') {
        this.router.oldRoute = oldRoute;
      } else {
        this.router.oldRoute = null;
      }
      this.fetchDataFromRouter();
    },
    'filter.fairGroups.filterValue': {
      handler(fairGroups) {
        if (this.splittedCategories) {
          const categoryKeys = Object.keys(this.filter.categoriesByFair);
          categoryKeys.forEach((categoryKey) => {
            this.filter.categoriesByFair[categoryKey].visible = false;
          });
          [].forEach.call(fairGroups, (fairGroup) => {
            if (this.filter.categoriesByFair[fairGroup.id]) {
              this.filter.categoriesByFair[fairGroup.id].visible = true;
            }
          });
        }
      }
    }
  },
};
